import React from 'react';

import { components } from 'react-select';

import classes from 'components/DesignSystem/Select/components/WbsOption/WbsOption.module.scss';

export const WbsOption = (props) => {
    const { value, label } = props;
    const char = '· ';
    return (
        <components.Option {...props}>
            <span className={classes.dotRepeat}>{char.repeat(value.wbs_level)}</span>
            {label}
        </components.Option>
    );
};
